/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiKeyWithOwner } from './ApiKeyWithOwner';
import {
    ApiKeyWithOwnerFromJSON,
    ApiKeyWithOwnerFromJSONTyped,
    ApiKeyWithOwnerToJSON,
    ApiKeyWithOwnerToJSONTyped,
} from './ApiKeyWithOwner';

/**
 * 
 * @export
 * @interface ListCompanyApiKeys200Response
 */
export interface ListCompanyApiKeys200Response {
    /**
     * 
     * @type {Array<ApiKeyWithOwner>}
     * @memberof ListCompanyApiKeys200Response
     */
    apiKeys: Array<ApiKeyWithOwner>;
    /**
     * Total number of active keys across all pages
     * @type {number}
     * @memberof ListCompanyApiKeys200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListCompanyApiKeys200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListCompanyApiKeys200Response
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof ListCompanyApiKeys200Response
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the ListCompanyApiKeys200Response interface.
 */
export function instanceOfListCompanyApiKeys200Response(value: object): value is ListCompanyApiKeys200Response {
    if (!('apiKeys' in value) || value['apiKeys'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function ListCompanyApiKeys200ResponseFromJSON(json: any): ListCompanyApiKeys200Response {
    return ListCompanyApiKeys200ResponseFromJSONTyped(json, false);
}

export function ListCompanyApiKeys200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCompanyApiKeys200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'apiKeys': ((json['apiKeys'] as Array<any>).map(ApiKeyWithOwnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'hasMore': json['hasMore'],
    };
}

export function ListCompanyApiKeys200ResponseToJSON(json: any): ListCompanyApiKeys200Response {
    return ListCompanyApiKeys200ResponseToJSONTyped(json, false);
}

export function ListCompanyApiKeys200ResponseToJSONTyped(value?: ListCompanyApiKeys200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiKeys': ((value['apiKeys'] as Array<any>).map(ApiKeyWithOwnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'hasMore': value['hasMore'],
    };
}

